<!-- notice the content placeholders -->
<!-- content-title -->
<!-- content-action -->
<!-- content-body -->

<div class="content-box-header">
    <ng-content select="[exl-content-box-title]"></ng-content>
    <ng-content select="[exl-content-box-action]"></ng-content>
</div>
<div class="content-box-body">
<ng-content select="[exl-content-box-body]"></ng-content>
<ng-content select="[exl-content-box-footer]"></ng-content>
</div>
